module.exports = __webpack_public_path__ + "img/mobile-phone-with-arrow.87d4ce67.png";